import React, { useEffect } from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { useHistory } from "react-router";
import InputBase from "@mui/material/InputBase";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Avatar from "@mui/material/Avatar";
import SearchIcon from "@mui/icons-material/Search";
import NestedList from "../../../plugins/provider/nestedMenu";
import MoreIcon from "@mui/icons-material/MoreVert";
import Drawer from "@mui/material/Drawer";
import Autocomplete from "@mui/material/Autocomplete";
import { LogoutComponent } from "../../../auth/logout";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { locationServiceMap } from "../../../auth/common";
import { serviceMap } from "../../centralOms/common/constants";
import MB from "../../../assets/MB.png";
import { Chip } from "@mui/material";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  height: "60%",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "relative",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#ffffff",
  right: 0,
  borderTopRightRadius: "2px",
  borderBottomRightRadius: "2px",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  backgroundColor: "#ffffff",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em)`,
    paddingRight: `calc(1em + ${theme.spacing(5)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "50ch",
      cursor: "pointer",
      backgroundColor: "#ffffff",
    },
  },
}));

export default function TopNavBar(props) {
  const user = JSON.parse(localStorage.getItem("user_details"));
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(false);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const firstName = localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")).firstName : "";
  const [entityId] = React.useState(JSON.parse(localStorage.getItem("user_details")).entityId);
  const [searchName, setSearchName] = React.useState("");
  const [searchId, setSearchId] = React.useState("");
  const [pathname, setPathname] = React.useState(props.location.pathname);
  const [childProviders, setChildProviders] = React.useState(user?.parentProvider?.isParent ?? null ? user.parentProvider.childEntities : {});
  const childProviderOptions = [];
  Object.keys(childProviders).forEach((prov) => {
    childProviderOptions.push({
      id: prov,
      label: childProviders[prov],
    });
  });
  const [selectedProviders, setSelectedProviders] = React.useState([]);
  const services = JSON.parse(localStorage.getItem("ValidServices"));
  const serviceSelected = localStorage.getItem("serviceSelected");
  const [service, setService] = React.useState(serviceSelected ? serviceSelected : "LABS");
  const searchNameLabels = service == "VISION" ? [
    { id: 1, label: "Order Id" },
    { id: 3, label: "Phone Number" },
  ] : [
    { id: 1, label: "Order Id" },
    { id: 2, label: "Request Id" },
    { id: 3, label: "Employee Id" },
    { id: 4, label: "Phone Number" },
    { id: 5, label: "Email" },
    { id: 6, label: "Name" },
  ];
  const providerFullName = user?.entityName;

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (props.location.pathname !== pathname) {
        setPathname(props.location.pathname);
      }
    }
    return () => {
      isMounted = false;
    };
  }, [props.location.pathname, pathname]);

  const clearFilters = () => {
    setSearchId("");
    setSearchName("");
    props.onSearchById(null);
    props.onSearchedDetails(null);
  };
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      clearFilters();
    }
    return () => {
      isMounted = false;
    };
  }, [props.resetFilters]);

  const [state, setState] = React.useState({
    left: false,
  });

  useEffect(() => {
    let isMounted = true;
    return () => {
      isMounted = false;
    };
  }, [entityId]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const toggleDrawerOnClick = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
    return open;
  };

  const createAppointment = () => {
    history.push("/" + localStorage.getItem("roleName") + "/create/appointments");
  };

  const showAppointment = () => {
    history.push("/" + localStorage.getItem("roleName") + "/appointments");
  };

  const searchByName = (event, values) => {
    values && values.label ? setSearchName(values.label) : setSearchName("");
  };

  const searchById = (event) => {
    setSearchId(event.target.value);
  };
  function callAppointmentDetails() {
    let ob = {
      Id: searchId.split(","),
      Name: searchName,
      isSearch: true,
    };
    props.setFetchData(!props.fetchData);
    if(service === "OFFLINE_CONSULTS") {
      history.push("/offlineConsults/allAppointments");
    } else if(service === "VISION" && searchName === "Order Id") {
      history.push("/vision/all");
    } else if(service === "LABS"){
      history.push("/" + localStorage.getItem("roleName") + "/appointments/all");
    }
    props.onSearchById(ob);
  }

  const list = (anchor) => (
    <Box sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }} role="presentation" onKeyDown={toggleDrawer(anchor, false)}>
      <NestedList
        service={service}
        toggleDrawerFunction={toggleDrawerOnClick(anchor, false)}
        anchorValue={anchor}
      ></NestedList>
    </Box>
  );

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={createAppointment}>Profile</MenuItem>
      <MenuItem onClick={showAppointment}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
      className="flex justify-start w-96"
    >
      <LogoutComponent mobileView={true}></LogoutComponent>
    </Menu>
  );

  const resetPagination = () => {
    localStorage.removeItem("req");
    let pgTrack = JSON.parse(localStorage.getItem("pageTracking"));
    if (pgTrack) {
      pgTrack.page = 1;
      pgTrack.sla = false;
      pgTrack.startTime = "";
      pgTrack.endTime = "";
      localStorage.setItem("pageTracking", JSON.stringify(pgTrack));
    }
  };

  const handleChange = (event, newValue) => {
    !newValue && setSelectedProviders([]);
    setSelectedProviders(newValue);
    let providerIds = newValue.map((val) => parseInt(val.id));
    let userDetail = JSON.parse(localStorage.getItem("user_details"));
    userDetail.selectedProviders = providerIds;
    localStorage.setItem("user_details", JSON.stringify(userDetail));
    props.setFetchData(!props.fetchData);
    props.onProvidersChanged(typeof newValue === 'string' ? newValue.split(',') : newValue)
  };

  const ITEM_HEIGHT = 30;
  const ITEM_PADDING_TOP = 4;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        zIndex: 10,
      },
    },
    style: {
      zIndex: 10,
    },
  };

  const handleChangeService = (value) => {
    setService(value);
    const location = locationServiceMap(localStorage.getItem("roleName"), value);
    localStorage.setItem("serviceSelected", value);
    setPathname(location);
    history.push(location);
  };

  return (
    <Box sx={{ flexGrow: 1 }} className="fixed inset-x-0 top-0 opacity-100 z-20">
      <AppBar position="static">
        <Toolbar className="bg-nav-bar-header h-16">
          <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2, color: "#000000" }}>
            <React.Fragment key={"left"}>
              <MenuIcon onClick={toggleDrawer("left", true)} />
              <Drawer anchor={"left"} open={state["left"]} onClose={toggleDrawer("left", false)}>
                {list("left")}
              </Drawer>
            </React.Fragment>
          </IconButton>
          <div className="flex p-0.5 rounded">
            <Link to={{ pathname: "/" }}>
              <div>
                <img src={MB} width="120px" alt="logo of provider"></img>
              </div>
              <div
                style={{ fontSize: "12px", color: "#050A4E" }}
                className="font-extrabold"
                onClick={() => {
                  resetPagination();
                  clearFilters();
                }}
              >
                PROVIDER CENTRAL
              </div>
            </Link>
          </div>

          <Autocomplete
            sx={{
              marginLeft: "40px",
              display: "inline-block",
              fontSize: "13px",
              "& input": {
                width: "130px",
                padding: "9px",
                cursor: "pointer",
                color: "#000000",
              },
            }}
            id="custom-input-demo"
            options={searchNameLabels}
            inputValue={searchName}
            value={searchName}
            onChange={searchByName}
            onInputChange={(_, newInputValue) => {
              setSearchName(newInputValue);
            }}
            renderInput={(params) => (
              <div ref={params.InputProps.ref} className="flex relative">
                <input type="text" {...params.inputProps} placeholder="Search By" />
              </div>
            )}
          />

          <Search>
            <StyledInputBase
              sx={{
                width: "280px",
                fontSize: "13px"
              }}
              value={searchId}
              onChange={searchById}
              placeholder="Search..."
              inputProps={{ "aria-label": "search", "max-width": "150px" }}
              onKeyPress={(e) => {
                if (e.key === "Enter") callAppointmentDetails();
              }}
            />
            {searchId && searchName && (
              <SearchIconWrapper
                onClick={() => {
                  clearFilters();
                  props.setFetchData(!props.fetchData);
                }}
              >
                <HighlightOffIcon className="text-black" />
              </SearchIconWrapper>
            )}
            {searchId && searchName ? (
              <SearchIconWrapper onClick={callAppointmentDetails}>
                <SearchIcon className="text-black"></SearchIcon>
              </SearchIconWrapper>
            ) : (
              <SearchIconWrapper>
                <SearchIcon className="bg-white text-black"></SearchIcon>
              </SearchIconWrapper>
            )}
          </Search>
          <Box sx={{ flexGrow: 1 }} />
          {services && services.length > 0 && (
            <Select
              className="mr-2 bg-white"
              sx={{
                display: "inline-block",
                fontSize: "13px",
                boxShadow: "none",
                ".MuiOutlinedInput-notchedOutline": { border: 0 },
              }}
              labelId="service"
              name="service"
              id="service"
              value={service}
              onChange={(event) => {
                handleChangeService(event.target.value);
              }}
              size="small"
              placeholder="Select Service"
              required
            >
              {services.map((ele) => (
                <MenuItem sx={{ fontSize: "13px", padding: "5px" }} value={ele}>
                  {serviceMap[ele]}
                </MenuItem>
              ))}
            </Select>
          )}
          {childProviderOptions && childProviderOptions.length > 0 ? (
            <FormControl sx={{ p: 0, width: 300, fontSize: "13px", height: "35px" }} size="small">
              <Autocomplete
                multiple
                className="bg-white"
                disableCloseOnSelect
                size="small"
                value={selectedProviders}
                sx={{
                  display: "inline-block",
                  ".MuiOutlinedInput-notchedOutline": { border: 0 },
                  "& input": {
                    fontSize: "13px",
                    cursor: "pointer",
                    color: "#000000",
                  },
                }}
                onChange={(event, newValue) => handleChange(event, newValue)}
                options={childProviderOptions}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderTags={(value, getTagProps) => (
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "nowrap",
                      overflowX: "auto",
                      alignItems: "center",
                    }}
                  >
                    {value.map((option, index) => (
                      <Chip {...getTagProps({ index })} key={option.id} label={option.label} size="small" />
                    ))}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Providers"
                    InputProps={{
                      ...params.InputProps,
                      style: {
                        display: "flex",
                        flex: 1,
                        height: "auto",
                        alignItems: "center",
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        flexWrap: "nowrap",
                      },
                      "& .MuiInputBase-input": {
                        width: 0,
                        minWidth: 30,
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          ) : (
            <div style={{ padding: "7px", width: 300 }} className="text-black text-sm rounded-sm bg-white">
              {providerFullName}
            </div>
          )}

          <Box sx={{ display: { xs: "none", md: "flex" } }} className="m-2">
            <IconButton size="large" aria-label="account of current user" className="cursor-default" aria-haspopup="true" color="inherit">
              <Avatar className="uppercase text-center" sx={{ width: 30, height: 30, fontSize: "15px", bgcolor: "#dc3e4d" }}>
                {firstName?.charAt(0)}
              </Avatar>
            </IconButton>
            <LogoutComponent mobileView={false}></LogoutComponent>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              className="text-gray-100"
            >
              <MoreIcon className="text-gray-100" />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
}
